<div class="app-tabs">
  <app-tabs-with-content [tabs]="tabs" [selectedTab]="selectedTab" 
  (onSelectTab)="navigateToTab($event)">
  </app-tabs-with-content>
</div>

<div *ngIf="selectedTab === Tab.SimpleDropdowns" class="row">
  <div class="configure-information-sidebar-wrapper">
    <app-case-form-section-container [title]="'label.dropdown_fields'" [iconClass]="'bi bi-clipboard-data'">
      <app-configure-information-sidebar [sidebarConfigType]="Tab.SimpleDropdowns"></app-configure-information-sidebar>
    </app-case-form-section-container>
  </div>

  <div class="configure-information-datatable-wrapper">
    <div>
      <app-configure-information-datatable></app-configure-information-datatable>
    </div>
  </div>
</div>

<div *ngIf="selectedTab === Tab.ComplexDropdowns" class="row">
  <div class="configure-information-sidebar-wrapper">
    <app-case-form-section-container [title]="'label.dropdown_fields'" [iconClass]="'bi bi-clipboard-data'">
      <app-configure-information-sidebar [sidebarConfigType]="Tab.ComplexDropdowns"></app-configure-information-sidebar>
    </app-case-form-section-container>
  </div>

  <div class="configure-information-datatable-wrapper">
    <div>
      <app-configure-information-datatable></app-configure-information-datatable>
    </div>
  </div>
</div>
